/* eslint-enable */
/* eslint-enable */

class AnimationGridArbitraryContent {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleGridArbitraryContent = this.sectionsContainer.querySelectorAll('.grid-arbitrary-content');
		
		if (!this.$moduleGridArbitraryContent.length)
			return;
		
		this.$moduleGridArbitraryContentElements = [];

		this.$moduleGridArbitraryContent.forEach(module => {
			this.$moduleGridArbitraryContentElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleGridArbitraryContent.forEach((module, index) => {
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleGridArbitraryContentElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		this.moduleGridArbitraryContent = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleGridArbitraryContent[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleGridArbitraryContentElements[index], { clearProps: true });
			}
        });
    
        this.moduleGridArbitraryContent.addLabel('step1');
        this.moduleGridArbitraryContent.to(this.$moduleGridArbitraryContent[index], { opacity: 1, duration: 1 }, 'step1');
		this.moduleGridArbitraryContent.to(this.$moduleGridArbitraryContentElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}

export default AnimationGridArbitraryContent;
